<template>
  <div class="qr-code-scanner-container">
    <a-tooltip class="link-tooltip" placement="topRight">
      <template #title>Share folder via QR code</template>
      <button
        class="qr-code-scanner-container__btn"
        :class="{ 'qr-code-scanner-container__active': dropdown }"
        @click="showScanner"
      >
        <img src="@/assets/icons/qr-code-icon.svg" alt="Icon" />
      </button>
    </a-tooltip>
    <Transition name="fade" mode="out-in">
      <div class="qr-code-scanner-container__scanner-dropdown" v-if="dropdown">
        <div class="qr-code-scanner-container__scanner-dropdown--scanner">
          <i class="icon icon-add_plus" @click="closeScanner()"></i>
          <h4>{{ activeFolder?.name ?? ''}}</h4>
          <img :src="QrCodeUrl" alt="Icon" />
          <p>Powered by Glocal</p>
        </div>
        <div class="qr-code-scanner-container__scanner-dropdown--buttons">
          <a-popover
            :visible="popoverVisible"
            @visibleChange="handleVisibleChange"
            placement="bottom"
          >
          <template #content>
            <p class="popover-text">Copied to clipboard</p>
          </template>
          <button  @click="copyQrCOde" class="button">
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.5 15.3711C10.875 15.3711 10.3438 15.1523 9.90625 14.7148C9.46875 14.2773 9.25 13.7461 9.25 13.1211C9.25 13.0336 9.25625 12.943 9.26875 12.8492C9.28125 12.7555 9.3 12.6711 9.325 12.5961L4.0375 9.52109C3.825 9.70859 3.5875 9.85547 3.325 9.96172C3.0625 10.068 2.7875 10.1211 2.5 10.1211C1.875 10.1211 1.34375 9.90234 0.90625 9.46484C0.46875 9.02734 0.25 8.49609 0.25 7.87109C0.25 7.24609 0.46875 6.71484 0.90625 6.27734C1.34375 5.83984 1.875 5.62109 2.5 5.62109C2.7875 5.62109 3.0625 5.67422 3.325 5.78047C3.5875 5.88672 3.825 6.03359 4.0375 6.22109L9.325 3.14609C9.3 3.07109 9.28125 2.98672 9.26875 2.89297C9.25625 2.79922 9.25 2.70859 9.25 2.62109C9.25 1.99609 9.46875 1.46484 9.90625 1.02734C10.3438 0.589844 10.875 0.371094 11.5 0.371094C12.125 0.371094 12.6562 0.589844 13.0938 1.02734C13.5312 1.46484 13.75 1.99609 13.75 2.62109C13.75 3.24609 13.5312 3.77734 13.0938 4.21484C12.6562 4.65234 12.125 4.87109 11.5 4.87109C11.2125 4.87109 10.9375 4.81797 10.675 4.71172C10.4125 4.60547 10.175 4.45859 9.9625 4.27109L4.675 7.34609C4.7 7.42109 4.71875 7.50547 4.73125 7.59922C4.74375 7.69297 4.75 7.78359 4.75 7.87109C4.75 7.95859 4.74375 8.04922 4.73125 8.14297C4.71875 8.23672 4.7 8.32109 4.675 8.39609L9.9625 11.4711C10.175 11.2836 10.4125 11.1367 10.675 11.0305C10.9375 10.9242 11.2125 10.8711 11.5 10.8711C12.125 10.8711 12.6562 11.0898 13.0938 11.5273C13.5312 11.9648 13.75 12.4961 13.75 13.1211C13.75 13.7461 13.5312 14.2773 13.0938 14.7148C12.6562 15.1523 12.125 15.3711 11.5 15.3711ZM11.5 3.37109C11.7125 3.37109 11.8906 3.29922 12.0344 3.15547C12.1781 3.01172 12.25 2.83359 12.25 2.62109C12.25 2.40859 12.1781 2.23047 12.0344 2.08672C11.8906 1.94297 11.7125 1.87109 11.5 1.87109C11.2875 1.87109 11.1094 1.94297 10.9656 2.08672C10.8219 2.23047 10.75 2.40859 10.75 2.62109C10.75 2.83359 10.8219 3.01172 10.9656 3.15547C11.1094 3.29922 11.2875 3.37109 11.5 3.37109ZM2.5 8.62109C2.7125 8.62109 2.89062 8.54922 3.03438 8.40547C3.17813 8.26172 3.25 8.08359 3.25 7.87109C3.25 7.65859 3.17813 7.48047 3.03438 7.33672C2.89062 7.19297 2.7125 7.12109 2.5 7.12109C2.2875 7.12109 2.10938 7.19297 1.96563 7.33672C1.82188 7.48047 1.75 7.65859 1.75 7.87109C1.75 8.08359 1.82188 8.26172 1.96563 8.40547C2.10938 8.54922 2.2875 8.62109 2.5 8.62109ZM11.5 13.8711C11.7125 13.8711 11.8906 13.7992 12.0344 13.6555C12.1781 13.5117 12.25 13.3336 12.25 13.1211C12.25 12.9086 12.1781 12.7305 12.0344 12.5867C11.8906 12.443 11.7125 12.3711 11.5 12.3711C11.2875 12.3711 11.1094 12.443 10.9656 12.5867C10.8219 12.7305 10.75 12.9086 10.75 13.1211C10.75 13.3336 10.8219 13.5117 10.9656 13.6555C11.1094 13.7992 11.2875 13.8711 11.5 13.8711Z"
                fill="#1C1B1F"
              />
            </svg>
            Share QR
          </button>
        </a-popover>
          
          <button @click="downloadQR" class="button primary-btn">
            <svg
              width="12"
              height="13"
              viewBox="0 0 12 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 9.55234C5.9 9.55234 5.80625 9.53672 5.71875 9.50547C5.63125 9.47422 5.55 9.42109 5.475 9.34609L2.775 6.64609C2.625 6.49609 2.55313 6.32109 2.55938 6.12109C2.56563 5.92109 2.6375 5.74609 2.775 5.59609C2.925 5.44609 3.10312 5.36797 3.30937 5.36172C3.51562 5.35547 3.69375 5.42734 3.84375 5.57734L5.25 6.98359V1.62109C5.25 1.40859 5.32188 1.23047 5.46562 1.08672C5.60938 0.942969 5.7875 0.871094 6 0.871094C6.2125 0.871094 6.39063 0.942969 6.53438 1.08672C6.67813 1.23047 6.75 1.40859 6.75 1.62109V6.98359L8.15625 5.57734C8.30625 5.42734 8.48438 5.35547 8.69063 5.36172C8.89688 5.36797 9.075 5.44609 9.225 5.59609C9.3625 5.74609 9.43438 5.92109 9.44063 6.12109C9.44688 6.32109 9.375 6.49609 9.225 6.64609L6.525 9.34609C6.45 9.42109 6.36875 9.47422 6.28125 9.50547C6.19375 9.53672 6.1 9.55234 6 9.55234ZM1.5 12.8711C1.0875 12.8711 0.734375 12.7242 0.440625 12.4305C0.146875 12.1367 0 11.7836 0 11.3711V9.87109C0 9.65859 0.071875 9.48047 0.215625 9.33672C0.359375 9.19297 0.5375 9.12109 0.75 9.12109C0.9625 9.12109 1.14062 9.19297 1.28437 9.33672C1.42813 9.48047 1.5 9.65859 1.5 9.87109V11.3711H10.5V9.87109C10.5 9.65859 10.5719 9.48047 10.7156 9.33672C10.8594 9.19297 11.0375 9.12109 11.25 9.12109C11.4625 9.12109 11.6406 9.19297 11.7844 9.33672C11.9281 9.48047 12 9.65859 12 9.87109V11.3711C12 11.7836 11.8531 12.1367 11.5594 12.4305C11.2656 12.7242 10.9125 12.8711 10.5 12.8711H1.5Z"
                fill="white"
              />
            </svg>
            Download QR
          </button>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import QRCode from 'qrcode';
import { copyUrl } from '@/utils/common.utils';
import {mapGetters} from 'vuex'

export default {
  data() {
    return {
      dropdown: false,
      QrCodeUrl: "",
      folderShareUrl:'',
      popoverVisible: false
    };
  },
  props: {
    folder: Object,
    isFolderCards: Boolean
  },
  watch: {
    folder: {
      handler(val) {
        if (val) {
          this.folderShareUrl = `${process.env.VUE_APP_REDIRECTION_URL}/workspaces/${this.$route.params.class}/${this.activeFolder.id}?shared=true`
          console.log("FOLDER URL",  this.folderShareUrl)
          QRCode.toDataURL( this.folderShareUrl)
          .then(url => {
            this.QrCodeUrl = url;
          })
          .catch(err => {
            console.error(err)
          })
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      activeFolder: 'folders/activeFolder'
    }),
    parentFolder() {
      return this.$store.getters["folders/getParentFolderDetails"];
    },
  },
  methods: {
    showScanner() {
      this.dropdown = !this.dropdown;
    },
    closeScanner() {
      this.dropdown = false;
    },
    async downloadQR() {
      try {
        const link = document.createElement('a');
        link.href = this.QrCodeUrl;
        link.download = 'qr_code.png';

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
      } catch (error) {
        console.error('Error generating QR code:', error);
      }
    },
    copyQrCOde(){
      this.popoverVisible = true;
      console.log("FOLDER URL", this.folderShareUrl);
      copyUrl(this.folderShareUrl);
      
    },
    handleVisibleChange(){
      setTimeout(() => {
        this.popoverVisible = false;
      }, 1000);
    }
  },
};
</script>

<style lang="scss">
.qr-code-scanner-container {
  position: relative;
  &__btn {
    width: 3.5rem;
    height: 3.5rem;
    border: none;
    outline: none;
    border-radius: 100% !important;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $color-white;
    cursor: pointer;
    img {
      width: 1.7rem;
      height: 1.7rem;
    }
  }
  &__active {
    background-color: $color-faded-blue !important;
  }
  &__scanner-dropdown {
    position: absolute;
    top: 9rem;
    z-index: 1;
    background: linear-gradient(154.64deg, #ffffff -15.66%, #e3e3e3 83.92%);
    padding: 1.7rem;
    min-width: 27.8rem;
    right: 1.5rem;
    border-radius: 10px;
    box-shadow: 0px 4px 35.900001525878906px 0px #00000040;
    &::after {
      width: 0;
      height: 0;
      content: "";
      position: absolute;
      top: -2rem;
      right: 1rem;
      border-left: 1.6rem solid transparent;
      border-right: 1.6rem solid transparent;
      border-bottom: 3rem solid #f4f4f4;
    }

    &--scanner {
      background-color: $color-white;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 1.6rem;
      margin-bottom: 1.7rem;
      .icon {
        position: relative;
        display: block;
        right: -0.5rem;
        top: -0.5rem;
        margin-left: auto;
        transform: rotate(45deg);
        cursor: pointer;
        font-size: 1.2rem;
        opacity: 1;
        color: $color-black;
      }
      h4 {
        color: $color-black;
        font-size: 1.2rem;
        font-family: $font-primary-medium;
        font-weight: 500;
        margin-bottom: 1.5rem;
        line-height: 1.6rem;
      }
      img {
        width: 16rem;
        height: 16rem;
        margin-bottom: 1.5rem;
      }
      p {
        color: $color-black;
        opacity: 0.7;
        font-size: 0.8rem;
        font-family: $font-primary;
        margin-bottom: 0.3rem;
        line-height: 1.2rem;
      }
    }
    &--buttons {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .button {
        border-radius: 100px !important;
        background-color: $color-white;
        width: 11.7rem;
        height: 4.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $color-black;
        font-size: 1.2rem;
        font-family: $font-primary;
        line-height: 1.6rem;
        margin: 0;
        border: none;
        outline: none;
        cursor: pointer;
        svg {
          margin-right: 0.8rem;
          width: 1.3rem;
          height: auto;
        }
      }
      .primary-btn {
        background-color: $color-primary;
        color: $color-white;
        font-family: $font-primary-medium;
        font-weight: 500;
        svg {
          margin-right: 0.5rem;
          width: 1.2rem;
          height: auto;
        }
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
